const NUMBER_EMOJI = ["0️⃣", "1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣", "7️⃣", "8️⃣", "9️⃣"];

export const formatFrameCountAsEmoji = (count) =>
  String(count)
    .split("")
    .map((d) => NUMBER_EMOJI[parseInt(d)] || d)
    .join("");

export const formatHintCountAsEmoji = (count) =>
  count
    .toString()
    .split("")
    .map((d) => NUMBER_EMOJI[parseInt(d)] || d)
    .join("");

export const generateShareText = ({
  startMovie,
  endMovie,
  finalFrameCount,
  steps_taken,
  currentStreak,
  baseUrl,
  includeSpoilers,
  route,
  hintCount,
}) => {
  const frameEmoji = formatFrameCountAsEmoji(finalFrameCount ?? steps_taken);
  const hintEmoji = formatHintCountAsEmoji(hintCount);
  const reelSummary = route.map((entry) => entry.name || entry).join(" → ");

  let text =
    `🎉 I just finished a Reely!` +
    `\n🎬 ${startMovie} → ${endMovie}` +
    `\n${frameEmoji} Frames | ${hintEmoji} Hint${hintCount === 1 ? "" : "s"}`;

  if (includeSpoilers) {
    text += `\n\n🎞️ My Reel:\n\n${reelSummary}`;
  }

  text +=
    `\n\n🔥 Streak: ${currentStreak} day${currentStreak !== 1 ? "s" : ""}` +
    `\n🍿 Play here:\n${baseUrl}`;

  return text;
};
